<script setup lang="ts">
import { computed } from 'vue'
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement
} from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Title, Tooltip, Legend)

interface UsageData {
  date: string
  count: number
}

const props = defineProps<{
  usageData: UsageData[]
}>()

const chartData = computed(() => {
  const sortedUsageData = [...props.usageData].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
  const dates = sortedUsageData.map((item) => {
    const date = new Date(item.date)
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  })
  const counts = sortedUsageData.map((item) => item.count)

  return {
    labels: dates,
    datasets: [
      {
        label: 'Usage',
        backgroundColor: 'rgba(126, 58, 242, 0.2)',
        borderColor: '#7e3af2',
        data: counts,
        fill: true,
        tension: 0.4,
        pointRadius: 0
      }
    ]
  }
})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false
    },
    title: {
      display: true,
      text: 'Usage History',
      color: '#fff',
      font: {
        size: 16
      }
    }
  },
  scales: {
    y: {
      beginAtZero: true,
      grid: {
        color: 'rgba(255, 255, 255, 0.1)'
      },
      ticks: {
        color: '#fff'
      }
    },
    x: {
      grid: {
        color: 'rgba(255, 255, 255, 0.1)'
      },
      ticks: {
        color: '#fff'
      }
    }
  }
}
</script>

<template>
  <div class="myCard q-pa-md">
    <div style="height: 300px">
      <Line :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template>
